import { ILookup, IPaginationResponse } from '../../../../core';

const accountTypesResponse: IPaginationResponse<ILookup<string>> = {
  items: [
    {
      englishName: 'ServiceProvider',
      id: 'dd73f266-9fdc-4234-be88-828e7f42cabb'
    },
    {
      englishName: 'team',
      id: '9d1fad93-f2da-446b-816a-d08530bfdfbc'
    },
    {
      englishName: 'tean',
      id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c'
    }
  ],
  paginationMetadata: {
    totalItemCount: 3,
    numberOfPages: 1,
    pageSize: 10,
    order: 'Ascending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

const accountTypeResponse: ILookup<string> = {
  englishName: 'teac',
  id: 'dd73f266-9fdc-4234-be88-828e7f42cabb'
};

export const accountTypesData = {
  accountTypesResponse,
  accountTypeResponse
};
